import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useContext, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { motion } from "framer-motion";
import { AppContext } from "../../../../context/AppContext";
import GetToken from "../../../../GetToken";
import { handleInvalidToken } from "../../../../AuthUtils";
import AnimationSpinner from "../../../../AnimationSpinner";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
// importing utility functions
import { truncateTextByChars } from "../../../../util";

// React icons import
import { IoIosArrowRoundForward } from "react-icons/io";
import { FaCheck, FaTowerBroadcast } from "react-icons/fa6";

// Material UI import
import Button from "@mui/material/Button";


// bootstrap import
import { Card } from "react-bootstrap";
import ErrorComponent from "../../../../pages/NoDataFound.jsx/NoError";
import EmptyIcon from "../../../../assets/images/error-image.jpg";


import TalkingBookStepper from "../TalkingBookStepper";
import { FaPlus } from "react-icons/fa";
const LIMIT = 10;

const BookTemplate = ({ bookToken, activeStep, setActiveStep, steps }) => {
	const [bookDetail, setBookDetail] = useState("");
	const [templates, setTemplates] = useState([]);
	const [templateLoading, setTemplateLoading] = useState(false);;
	const [offset, setOffset] = useState(1);
	const [totalItems, setTotalItems] = useState(0);
	const { base_url } = useContext(AppContext);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [defaultTemplates, setDefaultTemplates] = useState([]);

	//model states 
	const [modalActive, setModalActive] = useState(false)
	const modalRef = useRef(null);


	// model for preview index page implementation
	const modalVariants = {
		hidden: { opacity: 0, scale: 0.9 },
		visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
		exit: { opacity: 0, scale: 0.9, transition: { duration: 0.4 } }
	};
	const handleModelCloseClick = (event) => {
		if (event.target.classList.contains('history-image-model')) {
			closeModal();
		}
	};
	
	const closeModal = () => {
		setModalActive(false)
		fetchPageData();
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (modalRef.current && !modalRef.current.contains(event.target)) {
				closeModal();
			}
		};

		if (modalActive) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [modalActive]);


	const fetchPageData = async (isLoadMore = false) => {
		try {
			const token = GetToken();
			if (!token) {
				handleInvalidToken(navigate);
				return;
			}
			setLoading(true);
			const formData = new FormData();
			formData.append("action", "getBookCoverImages");
			formData.append("token", token);
			formData.append("book_token", bookToken);
			formData.append("limit", LIMIT);
			formData.append("page", isLoadMore ? offset : 1);

			const response = await axios.post(`${base_url}api/user/book`, formData);

			if (response.data.status) {
				const fetchedTemplates = response.data.items || [];
				const fetchedBookDetail = response.data.bookDetail;
				setTotalItems(response.data.totalItems || 0);
				setBookDetail(fetchedBookDetail);

				setTemplates((prevTemplates) =>
					isLoadMore
						? [...prevTemplates, ...fetchedTemplates]
						: fetchedTemplates
				);

				if (fetchedTemplates.length > 0) {
					setOffset(Number(response.data.page) + 1);
				}
				setTimeout(() => {
					setLoading(false);
				}, 1500);
			} else {
				setLoading(false);
				if (response.data.reset) {
					handleInvalidToken(navigate);
					return;
				}
				toast.warning(response.data.message);
				// Swal.fire({
				// 	icon: "warning",
				// 	title: "Warning",
				// 	text: response.data.message,
				// });
			}
		} catch (error) {
			setLoading(false);
			toast.error(error.response?.data?.message ||
						error.message ||
						"Something went wrong. Please try again.")

			// Swal.fire({
			// 	icon: "error",
			// 	title: "Error",
			// 	text:
			// 		error.response?.data?.message ||
			// 		error.message ||
			// 		"Something went wrong. Please try again.",
			// });
		}
	};

	useEffect(() => {
		fetchPageData();
	}, []);

	const fetchCreateTemplates = async (isLoadMore = false) => {
		try {
			const token = GetToken();
			if (!token) {
				handleInvalidToken(navigate);
				return;
			}
			setLoading(true);
			const formData = new FormData();
			formData.append("action", "getDefaultBookCovers");
			formData.append("token", token);

			const response = await axios.post(`${base_url}api/user/get-user-resource`, formData);

			if (response.data.status) {
				const fetchedTemplates = response.data.items || [];
				setDefaultTemplates(fetchedTemplates);

				setTimeout(() => {
					setLoading(false);
				}, 1500);
			} else {
				setLoading(false);
				if (response.data.reset) {
					handleInvalidToken(navigate);
					return;
				}
				toast.warning(response.data.message)
			}
		} catch (error) {
			setLoading(false);
			toast.error(error.response?.data?.message ||
				error.message ||
				"Something went wrong. Please try again.");
		}
	};

	useEffect(() => {
		fetchCreateTemplates();
	}, []);


	const handleNext = () => {
		if (!bookDetail.cover_image) {
			// Swal.fire("Please Select Book Cover");
			toast.error("Please Select Book Cover");
			return;
		}
		if (templates.length > 0 && activeStep < steps.length - 1) {
			setActiveStep((prevActiveStep) => prevActiveStep + 1);
		}
	};

	const handleLoadMore = () => {
		if (templates.length < totalItems) {
			setTemplateLoading(true);
			fetchPageData(true).finally(() => setTemplateLoading(false));
		}
	};

	const handleCreateTemplate = () => {
		setModalActive(true);
	};

	const handleBookCover = (slug) => {
		const bookURL = `${base_url}book/cover/design/?image=${base_url}${slug}`;
		window.open(bookURL, "_blank");
	}
	const modalChoseBookCover = async (id) => {
		try {
			const token = GetToken();
			if (!token) {
				handleInvalidToken(navigate);
				return;
			}
			setLoading(true);
			const formData = new FormData();
			formData.append("action", "useDefaultCoverTemplate");
			formData.append("token", token);
			formData.append("book_token", bookToken);
			formData.append("temp_id", id);

			const response = await axios.post(`${base_url}api/user/book`, formData);

			if (response.data.status) {
				setLoading(false);
				toast.success("Book cover template import successfully!");
				setModalActive(false);
				fetchPageData();
			} else {
				fetchPageData();
				setLoading(false);
				if (response.data.reset) {
					handleInvalidToken(navigate);
					return;
				}
				toast.warning(response.data.message);
			}
		} catch (error) {
			setLoading(false);
			toast.error(error.response?.data?.message ||
				error.message ||
				"Something went wrong. Please try again.");
				fetchPageData();
		}
	}
	const handleChooseCover = (coverIds) => {
		
		Swal.fire({
			title: "Confirm Selection",
			text: "Do you want to set this as your book cover?",
			icon: "question",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, set as cover!",
		}).then((result) => {
			if (result.isConfirmed) {
				saveBookCover(coverIds);
			}
		});
	};

	const saveBookCover = async (coverIds) => {
		try {
			const token = GetToken();
			if (!token) {
				handleInvalidToken(navigate);
				return;
			}
			setLoading(true);
			const formData = new FormData();
			formData.append("action", "saveBookCoverImage");
			formData.append("token", token);
			formData.append("book_token", bookToken);
			formData.append("cover_ids", coverIds);

			const response = await axios.post(`${base_url}api/user/book`, formData);

			if (response.data.status) {
				setLoading(false);
				toast.success("Book cover updated successfully!");
				fetchPageData();
			} else {
				setLoading(false);
				if (response.data.reset) {
					handleInvalidToken(navigate);
					return;
				}

				toast.warning(response.data.message);
				// Swal.fire({
				// 	icon: "warning",
				// 	title: "Warning",
				// 	text: response.data.message,
				// });
			}
		} catch (error) {
			setLoading(false);
			toast.error(error.response?.data?.message ||
				error.message ||
				"Something went wrong. Please try again.");
			// Swal.fire({
			// 	icon: "error",
			// 	title: "Error",
			// 	text:
			// 		error.response?.data?.message ||
			// 		error.message ||
			// 		"Something went wrong. Please try again.",
			// });
		}
	};

	return (
		<>
			<AnimationSpinner show={loading} />
			{modalActive && (

				<div
					className="history-image-model template-modal shadow rounded position-absolute"
					ref={modalRef}
					onClick={handleModelCloseClick}
				>
					<motion.div
						className="model-body position-relative"
						initial={{ opacity: 0, y: -20 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: 20 }}
						transition={{ duration: 0.3 }}
					>

						<div className="d-flex justify-content-between mb-2 btn-container gap-2 text-white py-2" style={{ width: "94%" }}>
							<h4 className="text-dark fw-semibold">Create template</h4>
							<Button
								className="btn btn-sm btn-primary text-white"
								style={{ zIndex: "1", height: "35px" }}
								onClick={closeModal}
							>
								<MdClose />
							</Button>
						</div>

						{defaultTemplates.length > 0 ? (
							<div className="row mx-4" style={{ marginTop: "70px" }}>
								{defaultTemplates.map((item, index) => (
									<div className="col-md-3 mb-3" key={index}>
										<Card className="custom-card">
											<div className="custom-card__image-container">
												<img
													src={base_url + item.tem_image_name}
													alt="template"
													className="custom-card__img"
												/>
												<div className="custom-card__overlay d-flex flex-column gap-2">
													<Button variant="contained" onClick={() => modalChoseBookCover(item.id)} className="custom-card__choose-btn">Choose</Button>
													<Button variant="contained" onClick={() => handleBookCover(item.tem_json_name)} className="custom-card__choose-btn">Edit</Button>
												</div>
											</div>
										</Card>
									</div>
								))}
							</div>
						) :
							(<ErrorComponent image={EmptyIcon} description={"No book cover templates available in page."} />)
						}
					</motion.div>
				</div>
			)}
			<div className="row align-items-center">
				<div className="col-lg-6 page-title-container">
					<h4 title={bookDetail.title} className="fw-semibold mb-1"> {bookDetail.title ? truncateTextByChars(bookDetail.title, 40) : "Loading..."}</h4>
					<p className="mb-1">Choose your preferred book cover </p>
				</div>
				<div className="col-lg-6 justify-content-end">
					<div className="d-flex justify-content-end gap-4">
						<Button
							onClick={handleCreateTemplate}
							variant="contained"
							color="secondary"
							title="Next step"
							className="ms-2"
							sx={{
								minWidth: "35px",
								height: "38px",
								padding: "0 17px",
							}}
							disabled={templates.length === 0 && bookDetail.cover_image == null}
						>
							<FaPlus size={12} fontWeight={600} width={12} color="white" style={{ marginRight: "10px" }} />
							Create Template
						</Button>
						<Button
							onClick={handleNext}
							variant="contained"
							color="secondary"
							title="Next step"
							className="ms-2"
							sx={{
								minWidth: "35px",
								height: "38px",
								padding: "0 17px",
							}}
							disabled={templates.length === 0 && bookDetail.cover_image == null}
						>
							Go to Next Step{" "}
							<span>
								<IoIosArrowRoundForward
									size={30}
									fontWeight={600}
									color="white"
								/>
							</span>
						</Button>
					</div>
				</div>
			</div>
			<div className="my-4">
				<TalkingBookStepper steps={steps} activeStep={activeStep} />
			</div>

			{bookDetail.cover_image && templates.length === 0 ?
				(<div className="row">
					<div className="col-md-3">
						<div className="bookCard selected_bookCard template-card" style={{ '&:hover': { '.select-category-img': { backgroundColor: "#e1e1e1" } } }}>
							<div className="Selected_BookCover">
								<span>Selected</span>
							</div>
							<div className="select-category-img" >
								<img
									src={bookDetail.cover_image}
									alt="Book Cover"
									className="img-fluid mx-auto d-block"
								/>
							</div>

						</div>
					</div>
					<div className="col-md-3">
						<div className="card template_button">
							<div className="card-body d-flex align-items-center justify-content-center">
						<Button onClick={handleCreateTemplate} variant="contained" color="secondary"> <FaPlus size={12} fontWeight={600} width={12} color="white" style={{ marginRight: "10px" }} /> Create template</Button>
						</div>
						</div>
					</div>
				</div>) :
				(templates.length === 0 ? (
					<div
						className="d-flex flex-column align-items-center justify-content-center"
						style={{ height: "50vh" }}
					>
				  <ErrorComponent image={EmptyIcon} description={"No templates found"} />
						<button
							onClick={handleCreateTemplate}
							className="btn btn-primary"
							style={{ borderRadius: "8px", padding: "10px 20px" }}
						>
							Create Template
						</button>
					</div>
				) : (
					<>
						<div className="row">
							{bookDetail.cover_image &&
								<div className="col-md-3">
									<div className="bookCard selected_bookCard template-card" style={{ '&:hover': { '.select-category-img': { backgroundColor: "#e1e1e1" } } }}>
										<div className="Selected_BookCover">
											<span>Selected</span>
										</div>
										<div className="select-category-img" >
											<img
												src={bookDetail.cover_image}
												alt="Book Cover"
												className="img-fluid mx-auto d-block"
											/>
										</div>

									</div>
								</div>
							}
							{templates.map((template, index) => (
								<div key={index} className="col-md-3">
									<div className="bookCard template-card">
										<div className="select-category-img">
											<img
												src={template.cover_image_url}
												alt="Book Cover"
												className="img-fluid mx-auto d-block"
											/>
											<div className="preview-theme-hover">
												<div
													className="theme-btn"
													onClick={() => handleChooseCover(template.ids)}
												>
													<span>Choose Cover</span>
												</div>
											</div>
										</div>
										<div
											className="title text-dark"
											title={template.bookcover_name}
										>
											{template.bookcover_name.length > 40
												? template.bookcover_name.substring(0, 40) + "..."
												: template.bookcover_name}
										</div>
									</div>
								</div>
							))}
						</div>
						<div className="row mt-4">
							<div className="col-12 d-flex justify-content-center">
								{templateLoading ? (
									<div className="spinner-border text-info" role="status">
										<span className="visually-hidden">Loading...</span>
									</div>
								) : (
									templates.length < totalItems && (
										<button
											onClick={handleLoadMore}
											className="btn btn-info px-4"
											style={{ borderRadius: "8px" }}
										>
											View More
										</button>
									)
								)}
							</div>
						</div>
					</>
				))
			}
		</>
	);
};

export default BookTemplate;
